export default "__VITE_ASSET__4ebcf6ec__"